/* HOST OF VINTAGE – theme.js */
(function () {
  'use strict';

  var R = (window.HOV && window.HOV.routes) || {};
  var root = (R.root || '/').replace(/\/?$/, '/');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- helpers ---------- */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  function toast(msg) {
    var t = $('#HovToast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(t._h);
    t._h = setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.hidden = true; }, 400);
    }, 2400);
  }

  function post(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Error');
        return d;
      });
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('no-scroll');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    });
    var f = $('button, a, input', el.querySelector('.drawer__panel'));
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 350);
  }
  function closeDrawer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { el.hidden = true; }, 450);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- cart rendering ---------- */
  var isCartPage = function () { return !!$('[data-cart-page]'); };

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
      b.classList.remove('bump-anim'); void b.offsetWidth; b.classList.add('bump-anim');
    });
    $$('[data-cart-count-label]').forEach(function (b) { b.textContent = '(' + count + ')'; });
  }

  function refreshCart() {
    if (isCartPage()) { window.location.reload(); return Promise.resolve(); }
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-body]', doc);
        var current = $('#CartDrawer [data-cart-body]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return getCart().then(function (c) { updateCount(c.item_count); });
      });
  }

  function afterAdd() {
    return refreshCart().then(function () {
      if (window.HOV.cartType === 'page' && !isCartPage()) { window.location.href = R.cart || '/cart'; return; }
      if (!isCartPage()) openDrawer($('#CartDrawer'));
    });
  }

  /* Add variants, skipping ones already in the cart (digital = 1 each) */
  function addVariants(ids) {
    return getCart().then(function (cart) {
      var inCart = cart.items.map(function (i) { return String(i.variant_id); });
      var items = ids.filter(function (id) { return id && inCart.indexOf(String(id)) === -1; })
        .map(function (id) { return { id: Number(id), quantity: 1 }; });
      if (!items.length) { toast('Schon im Warenkorb'); return null; }
      return post(R.cartAdd || '/cart/add', { items: items });
    });
  }

  function withLoading(btn, p) {
    if (btn) btn.classList.add('is-loading');
    return p.catch(function (e) { toast(e.message || 'Fehler – bitte erneut versuchen'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest('[data-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-open'))); return; }

    var cartOpener = t.closest('[data-open-cart]');
    if (cartOpener && window.HOV.cartType !== 'page' && !isCartPage()) { e.preventDefault(); openDrawer($('#CartDrawer')); return; }

    var closer = t.closest('[data-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }

    var menuLink = t.closest('.menu-drawer a');
    if (menuLink) { closeDrawer(menuLink.closest('.drawer')); }

    var qa = t.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      withLoading(qa, addVariants([qa.getAttribute('data-quick-add')]).then(function (r) { if (r) return afterAdd(); }));
      return;
    }

    var up = t.closest('[data-upgrade]');
    if (up) {
      e.preventDefault();
      var id = up.getAttribute('data-upgrade');
      withLoading(up, post(R.cartClear || '/cart/clear')
        .then(function () { return post(R.cartAdd || '/cart/add', { items: [{ id: Number(id), quantity: 1 }] }); })
        .then(function () { toast('Upgrade aktiviert ✓'); return afterAdd(); }));
      return;
    }

    var rm = t.closest('[data-remove-line]');
    if (rm) {
      e.preventDefault();
      withLoading(rm, post(R.cartChange || '/cart/change', { id: rm.getAttribute('data-remove-line'), quantity: 0 }).then(refreshCart));
      return;
    }

    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      var i = thumb.getAttribute('data-thumb');
      $$('[data-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === thumb); });
      $$('[data-media]').forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-media') === i); });
    }
  });

  /* ---------- consent + checkout ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-consent]')) {
      var form = e.target.closest('form');
      var btn = form && $('[data-checkout]', form);
      if (btn) btn.setAttribute('aria-disabled', e.target.checked ? 'false' : 'true');
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-cart-form]')) return;
    var consent = $('[data-consent]', form);
    if (consent && !consent.checked) {
      e.preventDefault();
      var lbl = consent.closest('.consent');
      lbl.classList.remove('is-shake'); void lbl.offsetWidth; lbl.classList.add('is-shake');
      return;
    }
    if (consent) {
      e.preventDefault();
      var stamp = new Date().toISOString();
      post(R.cartUpdate || '/cart/update', { attributes: { 'Zustimmung digitale Inhalte': 'Ja – ' + stamp } })
        .catch(function () {})
        .finally(function () { window.location.href = root + 'checkout'; });
    }
  });
  /* ---------- product form (main + bumps) ---------- */
  function initProductForm(form) {
    var base = Number(form.getAttribute('data-base-price')) || 0;
    var currency = form.getAttribute('data-currency');
    var idInput = $('[data-variant-id]', form);
    var select = $('[data-variant-select]', form);

    function total() {
      var sum = base;
      $$('input[name="bump"]:checked', form).forEach(function (b) { sum += Number(b.getAttribute('data-price')) || 0; });
      $$('[data-total]').forEach(function (el) { el.textContent = money(sum, currency); });
    }
    form.addEventListener('change', function (e) {
      if (e.target === select) {
        idInput.value = select.value;
        base = Number(select.selectedOptions[0].getAttribute('data-price')) || base;
      }
      total();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var ids = [idInput.value].concat($$('input[name="bump"]:checked', form).map(function (b) { return b.value; }));
      var btn = $('[data-atc]', form);
      withLoading(btn, addVariants(ids).then(function (r) { if (r) return afterAdd(); }));
    });
    total();

    /* sticky buy bar */
    var bar = $('[data-sticky-buy]');
    var atc = $('[data-atc]', form);
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = $('[data-sticky-submit]', bar); if (b) b.tabIndex = show ? 0 : -1;
      }).observe(atc);
      var sb = $('[data-sticky-submit]', bar);
      if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : atc.click(); });
    }
  }

  /* ---------- quiz ---------- */
  function initQuiz(q) {
    var steps = $$('[data-quiz-step]', q);
    var bar = $('[data-quiz-bar]', q);
    var results = $('[data-quiz-results]', q);
    var answers = [];
    function show(i) {
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      bar.style.width = (i / steps.length * 100) + '%';
    }
    q.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-answer]');
      if (opt) {
        var step = opt.closest('[data-quiz-step]');
        var idx = Number(step.getAttribute('data-quiz-step'));
        $$('[data-quiz-answer]', step).forEach(function (o) { o.classList.toggle('is-picked', o === opt); });
        answers[idx] = Number(opt.getAttribute('data-quiz-answer'));
        setTimeout(function () {
          if (idx + 1 < steps.length) { show(idx + 1); return; }
          var avg = answers.reduce(function (a, b) { return a + b; }, 0) / answers.length;
          var pick = Math.min(3, Math.max(1, Math.round(avg)));
          steps.forEach(function (s) { s.classList.remove('is-active'); });
          bar.style.width = '100%';
          results.hidden = false;
          var shown = false;
          $$('[data-quiz-result]', results).forEach(function (r) {
            var match = Number(r.getAttribute('data-quiz-result')) === pick;
            r.hidden = !match; if (match) shown = true;
          });
          if (!shown) { var first = $('[data-quiz-result]', results); if (first) first.hidden = false; }
        }, 260);
      }
      if (e.target.closest('[data-quiz-restart]')) {
        answers = [];
        results.hidden = true;
        $$('.is-picked', q).forEach(function (o) { o.classList.remove('is-picked'); });
        show(0);
      }
    });
    show(0);
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- All-Access-Kaufleiste (Handy) ---------- */
  function initAABar() {
    var bar = $('[data-aa-bar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hideOn = $$('[data-aa-section], .pt, .bb, .fh, .footer');
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
      var show = visible.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var b = $('button', bar); if (b) b.tabIndex = show ? 0 : -1;
    }, { threshold: 0 });
    hideOn.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Paket-Baukasten ---------- */
  function initBuilder(root) {
    var cur = root.getAttribute('data-currency');
    var t1 = +root.dataset.t1, p1 = +root.dataset.p1, t2 = +root.dataset.t2, p2 = +root.dataset.p2;
    var passPrice = +root.dataset.passPrice || 0, passId = root.dataset.passId;
    var out = function (k) { return $('[data-b="' + k + '"]', root); };
    var addBtn = $('[data-builder-add]', root), passBtn = $('[data-builder-pass]', root);
    function update() {
      var boxes = $$('[data-builder-item]:checked', root);
      var n = boxes.length, sub = 0;
      boxes.forEach(function (b) { sub += +b.dataset.price; });
      var pct = n >= t2 ? p2 : (n >= t1 ? p1 : 0);
      var total = Math.round(sub * (100 - pct) / 100);
      out('count').textContent = n;
      out('sub').textContent = money(sub, cur);
      out('pct').textContent = pct;
      out('save').textContent = '−' + money(sub - total, cur);
      out('total').textContent = money(total, cur);
      $$('[data-step]', root).forEach(function (el) { el.classList.toggle('is-on', (el.dataset.step === '1' && n >= t1) || (el.dataset.step === '2' && n >= t2)); });
      var hint = out('hint');
      if (n === 0) hint.textContent = 'Tippe Guides an – ' + t1 + ' Guides = −' + p1 + ' %';
      else if (n < t1) hint.textContent = 'Noch ' + (t1 - n) + ' Guide → −' + p1 + ' %';
      else if (n < t2) hint.textContent = 'Noch ' + (t2 - n) + ' Guide → −' + p2 + ' %';
      else hint.textContent = 'Maximaler Staffelrabatt aktiv ✓';
      addBtn.disabled = n === 0;
      if (passBtn && passPrice) {
        var diff = passPrice - total;
        var show = n >= 2 && diff <= passPrice * 0.6;
        passBtn.hidden = !show;
        if (show) out('passmsg').innerHTML = diff > 0
          ? 'Nur <strong>+' + money(diff, cur) + '</strong> mehr für <em>alle</em> Guides + Extras'
          : 'Der Host Pass ist <strong>günstiger</strong> – und enthält alles';
      }
    }
    root.addEventListener('change', update);
    addBtn.addEventListener('click', function () {
      var ids = $$('[data-builder-item]:checked', root).map(function (b) { return b.value; });
      withLoading(addBtn, addVariants(ids).then(function (r) { if (r) return afterAdd(); }));
    });
    if (passBtn) passBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      withLoading(passBtn, addVariants([passId]).then(function (r) { if (r) return afterAdd(); }));
    });
    update();
  }

  /* ---------- Gewinn-Rechner ---------- */
  function initCalc(root) {
    var inp = function (k) { return $('[data-in="' + k + '"]', root); };
    function eur(n) { return Math.round(n).toLocaleString('de-DE') + ' €'; }
    function update() {
      var buy = +inp('buy').value, sell = +inp('sell').value, qty = +inp('qty').value;
      var cost = buy * qty, rev = sell * qty, profit = rev - cost;
      $('[data-out="buy"]', root).textContent = eur(buy);
      $('[data-out="sell"]', root).textContent = eur(sell);
      $('[data-out="qty"]', root).textContent = qty;
      $('[data-out="cost"]', root).textContent = eur(cost);
      $('[data-out="rev"]', root).textContent = eur(rev);
      var pEl = $('[data-out="profit"]', root);
      pEl.textContent = (profit >= 0 ? '+' : '') + eur(profit);
      pEl.classList.toggle('is-neg', profit < 0);
      var max = Math.max(cost, rev, 1);
      $('[data-bar="cost"]', root).style.width = (cost / max * 100) + '%';
      $('[data-bar="rev"]', root).style.width = (rev / max * 100) + '%';
      $$('input[type=range]', root).forEach(function (r) { r.style.setProperty('--fill', ((r.value - r.min) / (r.max - r.min) * 100) + '%'); });
    }
    root.addEventListener('input', function (e) {
      if (e.target.matches('input[type=range]')) { $$('[data-preset]', root).forEach(function (b) { b.classList.remove('is-active'); }); update(); }
    });
    $$('[data-preset]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-preset]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        inp('buy').value = b.dataset.buy; inp('sell').value = b.dataset.sell; inp('qty').value = b.dataset.qty;
        update();
      });
    });
    update();
  }

  /* ---------- Guide-Filter ---------- */
  function initFilter(root) {
    root.addEventListener('mousemove', function (e) {
      var row = e.target.closest('.gr'); if (!row) return;
      var r = row.getBoundingClientRect();
      row.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      row.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]'); if (!chip) return;
      var f = chip.dataset.filter;
      $$('[data-filter]', root).forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      $$('[data-uses]', root).forEach(function (row) {
        var on = f === 'all' || (' ' + row.dataset.uses + ' ').indexOf(' ' + f + ' ') > -1;
        row.classList.toggle('is-hidden', !on);
      });
    });
  }

  /* ---------- FAQ-Reiter ---------- */
  function initTabs(root) {
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tab]'); if (!tab) return;
      var t = tab.dataset.tab;
      $$('[data-tab]', root).forEach(function (x) { var on = x === tab; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
      $$('[data-cat]', root).forEach(function (d) { d.hidden = !(t === 'all' || d.dataset.cat === t); });
    });
  }

  /* ---------- Wende-Karten ---------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-flip]'); if (!c) return;
    var on = !c.classList.contains('is-flipped');
    c.classList.toggle('is-flipped', on); c.setAttribute('aria-pressed', on);
  });

  /* ---------- init ---------- */
  function init() {
    $$('[data-product-form]').forEach(initProductForm);
    $$('[data-quiz]').forEach(initQuiz);
    initReveal();
    initAABar();
    $$('[data-builder]').forEach(initBuilder);
    $$('[data-calc]').forEach(initCalc);
    $$('[data-filter-scope]').forEach(initFilter);
    $$('[data-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-form]', e.target).forEach(initProductForm);
    $$('[data-quiz]', e.target).forEach(initQuiz);
    $$('[data-builder]', e.target).forEach(initBuilder);
    $$('[data-calc]', e.target).forEach(initCalc);
    $$('[data-filter-scope]', e.target).forEach(initFilter);
    $$('[data-tabs]', e.target).forEach(initTabs);
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
